import React, { useState } from "react";
import { Chart } from "primereact/chart";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import ChartSkeleton from "../../../Skeletons/ChartSkeleton";
import { getWeekPartGraphOptions } from "../../../../utils/chartOptions/dashboard/frequency";

const WeekPart = React.memo(function WeekPart(props) {
  const options = getWeekPartGraphOptions(
    props?.weekPartGraph,
    props?.activeButtonWeekPart,
  );
  const handleClick = (label) => props?.setActiveButtonWeekPart(label);

  return (
    <>
      <div className="mt-4" style={{ maxWidth: "100%" }}>
        <div className="mb-4">
          <h5 className="fw-bold mb-2 text-start">
            <span>Week Part</span>
            <div
              className="d-flex align-items-center gap-2"
              style={{ float: "right" }}
            >
              {/* <Button
                label="% of Total"
                className={`px-3 py-2 fw-bold fs-6 ${
                  props?.activeButtonWeekPart === "% OF TOTAL"
                    ? "btn-primary text-white"
                    : "btn-light text-dark"
                }`}
                onClick={() => handleClick("% OF TOTAL")}
                style={{
                  borderRadius: "10px",
                  border: "none",
                  height: "25px",
                  backgroundColor:
                    props?.activeButtonWeekPart === "% OF TOTAL"
                      ? "#002D42"
                      : "#E0E0E0",
                  cursor: "default",
                }}
              /> */}
              {/* <Button
                label="# of Uses"
                className={`px-3 py-2 fw-bold fs-6 ${
                  props?.activeButtonWeekPart === "# OF USES"
                    ? "btn-primary text-white"
                    : "btn-light text-dark"
                }`}
                onClick={() => handleClick("# OF USES")}
                style={{
                  borderRadius: "10px",
                  border: "none",
                  height: "25px",
                  backgroundColor:
                    props?.activeButtonWeekPart === "# OF USES"
                      ? "#002D42"
                      : "#E0E0E0",
                }}
              /> */}
            </div>
          </h5>
          {/* <h6 className="fw-bold mb-2 text-start">Base: Uses</h6> */}
          <p
            className="mb-0 text-start fw-bold fs-12 pb-3"
            style={{ color: "#6c757d" }}
          >
            {props?.activeButtonWeekPart === "# OF USES"
              ? "Average count of product uses by week part"
              : "% of product uses by week part"}
          </p>
          <div className="col-12 pb-5">
            {!props?.weekPartLoader ? (
              <Chart
                type="bar"
                data={props?.weekPartGraph}
                options={options}
                redraw={(props?.isFilterHide || props?.showSidebar).toString()}
              />
            ) : (
              <ChartSkeleton />
            )}
          </div>
          <Divider />
        </div>
      </div>
    </>
  );
});

export default WeekPart;
